// src/pages/admin/AdminDashboardPage.tsx
import React from 'react';
import { useAdminDashboard } from '../hooks';
import { AdminStats, QuickActions, AuditLogTable } from '../components';
import { useAuditLogs } from '../hooks';

export const AdminDashboardPage: React.FC = () => {
  const { data: dashboard, isLoading: dashboardLoading } = useAdminDashboard();
  const { data: logsData, isLoading: logsLoading } = useAuditLogs({ limit: 10 });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-display font-semibold text-navy">Admin Dashboard</h1>
        <p className="text-warm-gray">Platform overview and quick actions</p>
      </div>

      {dashboard && (
        <AdminStats data={dashboard} isLoading={dashboardLoading} />
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <AuditLogTable 
            logs={logsData?.items || []} 
            isLoading={logsLoading} 
          />
        </div>
        <div>
          <QuickActions 
            pendingModeration={dashboard?.pending_moderation}
            pendingVendors={dashboard?.pending_vendors}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;


